var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeveless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.4593C20 12.157 19.9282 11.8611 19.8168 11.5802C19.0467 9.63794 18.3998 5.75641 18.3381 2.49938C18.3329 2.22329 18.1095 2 17.8333 2H16.1667C15.8905 2 15.6675 2.22314 15.6395 2.49786C15.6092 2.79507 15.5539 3.11851 15.4758 3.45478C13.4035 4.95952 10.5965 4.95952 8.52422 3.45478C8.44607 3.11851 8.3908 2.79507 8.36049 2.49786C8.33247 2.22314 8.10948 2 7.83333 2H6.16667C5.89052 2 5.66708 2.22329 5.66185 2.49938C5.60017 5.75641 4.95329 9.63794 4.1832 11.5802C4.07179 11.8611 4 12.157 4 12.4593V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V12.4593ZM9.27301 5.56446C11.0228 6.25629 12.9772 6.25629 14.727 5.56446C14.0728 6.89955 13.119 8 12 8C10.881 8 9.92716 6.89955 9.27301 5.56446Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeveless);
export default __webpack_public_path__ + "static/media/sleeveless.736023638c8395db8adac90a3b44edee.svg";
export { ForwardRef as ReactComponent };